import {
  Component,
  input,
  signal,
  OnInit,
  OnDestroy,
  effect,
} from '@angular/core';

@Component({
  selector: 'fini-login-splashscreen',
  templateUrl: './login-splashscreen.component.html',
  styleUrls: ['./login-splashscreen.component.scss'],
  standalone: false,
})
export class LoginSplashscreenComponent {
  isClosing = signal(false);
  isHidden = signal(false);
  isLoadingSlowly = signal(false);

  authcheck = input<boolean | undefined>();
  timeoutTrigger = signal<number | null>(null);

  constructor() {
    effect(() => {
      if (this.authcheck()) {
        this.timeoutTrigger.set(Date.now());
      }
    });

    effect(() => {
      const triggerValue = this.timeoutTrigger();

      if (triggerValue) {
        console.log(`setting closing at ${triggerValue}`);
        this.isClosing.set(true);
        const timeoutId = setTimeout(() => {
          console.log('setting hidden after timeout at ', Date.now());
          this.isHidden.set(true);
          this.isClosing.set(false);
          this.timeoutTrigger.set(null);
        }, 500);

        return () => {
          this.isLoadingSlowly.set(false);
          clearTimeout(timeoutId);
        };
      }
      // Add an explicit return statement for the case when triggerValue is null
      this.isLoadingSlowly.set(false);
      return undefined; // Or return undefined;
    });

    setTimeout(() => {
      this.isLoadingSlowly.set(true);
    }, 500);
  }
}
